import { useEffect } from 'react';

const TidioChat = () => {
  useEffect(() => {
    // Check if the script is already added
    if (document.querySelector('script[src*="tidio"]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = '//code.tidio.co/ojs4do8bkxzviriybbpgdetlqpk1h9al.js';
    script.async = true;
    
    document.body.appendChild(script);

    return () => {
      const tidioScript = document.querySelector('script[src*="tidio"]');
      if (tidioScript) {
        document.body.removeChild(tidioScript);
      }
    };
  }, []);

  return null;
};

export default TidioChat;
